import * as React from "react";
import Component from "../../AbstractComponent";
import Payment2Summary from "./Payment2Summary";
import Payment2DetailsReadonly from "./Payment2DetailsReadonly";
import Payment2DetailsEditable from "./Payment2DetailsEditable";
import { PaymentInterface } from "../../../Entity/Entities/Payment/PaymentInterface";
import {
	Card
} from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

export default class Payment2Wrapper extends Component {
	public state = {
		isSummaryView: this.props.dialogPresentation ? false : !this.props.mainCardPresentation,
		isEditableView: false
	};

  constructor(public props) {
    super(props);
		let isSummaryView = props.isSummaryView || true;

		if (this.props.dialogPresentation) {
			isSummaryView = false;
		}

		if (typeof this.props.isSummaryView !== "undefined") {
			isSummaryView = this.props.isSummaryView;
		}

		this.state.isSummaryView = isSummaryView;
	}

	public changeView = (): void => {
		if (typeof this.props.toggleSummaryView === 'function') {
			this.props.toggleSummaryView();
		}
		
		if (typeof this.props.paymentIdForDetailsPresentation !== "undefined") {
			this.props.changeSettledIdForDetailsPresentation.call(this, null);

			if (this.props.paymentIdForDetailsPresentation === this.props.payment?.id) {
				this.props.changePaymentIdForDetailsPresentation.call(this, null);
			} else {
				this.props.changePaymentIdForDetailsPresentation.call(this, this.props.payment?.id);
			} 
		} else {
			this.setState({
				isSummaryView: !this.state.isSummaryView
			})
		}
	}

	public openEditableView = () => {
		this.setState({
			isEditableView: true,
			isSummaryView: false
		})
	}
	
  public render() {
		const payment: PaymentInterface = this.props.payment;
		const linkedCharge = this.props.linkedCharge;
		const isSummaryView = typeof this.props.paymentIdForDetailsPresentation !== "undefined" ? 
														this.props.paymentIdForDetailsPresentation !== payment?.id : 
														this.state.isSummaryView;

    return (
			<Card 
				className="card no-padding" 
				style={{position: "relative"}}
				onClick={isSummaryView ? this.changeView : null}
			>
				<div 
					className="right-buttons" 
					style={{
						position: "absolute",
						right: 0,
						width: "100%",
						height: "60px",
						display: "flex",
						justifyContent: "flex-end",
						paddingRight: "7px"
					}} 
					onClick={!isSummaryView ? this.changeView : null}
				>
					{
						this.props.dialogPresentation ? 
						null :
						isSummaryView ? 
							<ExpandMore style={{cursor: "pointer", marginTop: "6px"}} onClick={this.changeView}/> : 
							<ExpandLess style={{cursor: "pointer", marginTop: "6px"}} onClick={this.changeView}/>
					}
				</div>

				<div className="main-inner-wrapper" style={{padding: "10px 40px 10px 10px", marginBottom: "10px"}}>
					<div style={{display: isSummaryView ? "block" : "none"}}>
						<Payment2Summary {...this.props} payment={payment} linkedCharge={linkedCharge} />
					</div>

					<div style={{display: !isSummaryView && !this.state.isEditableView ? "block" : "none"}}>
						<Payment2DetailsReadonly {...this.props} payment={payment} linkedCharge={linkedCharge} openEditableView={this.openEditableView} updateState={this.props.updateFullState} />
					</div>

					<div style={{display: !isSummaryView && this.state.isEditableView ? "block" : "none"}}>
						<Payment2DetailsEditable {...this.props} payment={payment} ref={this.props.refPaymentDetails} updateState={this.props.updateState} />
					</div>	
				</div>
				<div style={{height: "1px"}}></div>
			</Card>
    );
  }
}
